import * as React from 'react';
import { Paper, BottomNavigation, BottomNavigationAction, useMediaQuery, useTheme } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PeopleIcon from '@mui/icons-material/People';
import AssignmentIcon from '@mui/icons-material/Assignment';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import EventIcon from '@mui/icons-material/Event';
import SettingsIcon from '@mui/icons-material/Settings';
import DatabaseIcon from '../Icons/Database/DatabaseIcon';

const navigationItems = [
  { label: 'Home', value: 'Home', icon: <HomeIcon /> },
  { label: 'Session', value: 'Session', icon: <EventIcon /> },
  // { label: 'Registed', value: 'Registed', icon: <PeopleIcon /> },
  // { label: 'Registration', value: 'Registration', icon: <PersonAddIcon /> },
  // { label: 'Task', value: 'Task', icon: <AssignmentIcon /> },
  { label: 'Volunteering', value: 'Volanteering', icon: <VolunteerActivismIcon /> },
  { label: 'DB Mgmt', value: 'DbManagement', icon: <DatabaseIcon /> },
];

export default function BottomNav({ currentPage, onPageChange, hidden }) {
  const [value, setValue] = React.useState(currentPage);
  const theme = useTheme();
  const isNarrow = useMediaQuery(theme.breakpoints.down('sm'));

  React.useEffect(() => {
    setValue(currentPage);
  }, [currentPage]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (onPageChange) {
      onPageChange(newValue);
    }
  };

  if (hidden) {
    return null;
  }

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        zIndex: 1000
      }} 
      elevation={3}
    >
      <BottomNavigation
        value={value}
        onChange={handleChange}
        showLabels={!isNarrow}
      >
        {navigationItems.map((item) => (
          <BottomNavigationAction
            key={item.value}
            label={item.label}
            value={item.value}
            icon={item.icon}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
